import(/* webpackMode: "eager" */ "/app/app/articles/exploring-the-most-spectacular-dive-sites-in-the-maldives/page.tsx");
